// Referral code capture + persistence (30 days)
const KEY = "asure_ref_code";
const KEY_EXP = "asure_ref_exp";

export function captureRefFromUrl() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const ref = (params.get("ref") || "").toUpperCase().trim();
  if (!ref) return;
  const exp = Date.now() + 30 * 24 * 60 * 60 * 1000;
  localStorage.setItem(KEY, ref);
  localStorage.setItem(KEY_EXP, String(exp));
}

export function getRefCode() {
  if (typeof window === "undefined") return "";
  const exp = Number(localStorage.getItem(KEY_EXP) || 0);
  if (exp && exp < Date.now()) {
    localStorage.removeItem(KEY);
    localStorage.removeItem(KEY_EXP);
    return "";
  }
  return localStorage.getItem(KEY) || "";
}

export function clearRefCode() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(KEY_EXP);
}
